<script setup lang="ts">
import { useRoute } from 'vue-router'

import AppLogo from '@/components/AppLogo.vue'
import ThemeToggle from '@/components/ThemeToggle.vue'

const route = useRoute()
</script>

<template>
  <v-app-bar flat color="transparent" class="px-2" density="comfortable">
    <router-link
      to="/"
      class="text-decoration-none text-high-emphasis"
      aria-label="Live Survey home"
    >
      <AppLogo />
    </router-link>
    <v-spacer />
    <ThemeToggle />
    <v-btn v-if="route.name !== 'login'" to="/login" variant="text" class="ml-1"
      >Presenter sign in</v-btn
    >
  </v-app-bar>
  <v-main class="public-main">
    <div class="public-main__glow" aria-hidden="true" />
    <slot />
  </v-main>
</template>

<style scoped>
.public-main {
  position: relative;
  min-height: 100dvh;
  background: rgb(var(--v-theme-background));
}

.public-main__glow {
  position: absolute;
  inset: 0 0 auto;
  height: 520px;
  background:
    radial-gradient(600px 300px at 15% 0%, rgb(99 102 241 / 0.18), transparent 70%),
    radial-gradient(500px 280px at 90% 10%, rgb(20 184 166 / 0.14), transparent 70%);
  pointer-events: none;
}

.public-main :deep(> .v-main__scroller),
.public-main > :not(.public-main__glow) {
  position: relative;
}
</style>
